import { Can } from 'providers/casl'

export const onDomainAccess = (can: Can) => {
  can('access', 'DomainPage-list')
  can('access', 'DomainPage-add')
  can('access', 'DomainPage-edit')
}

export const onDomainCreateUpdateDelete = (can: Can) => {
  can('create', 'Domain')
  can('update', 'Domain')
  can('delete', 'Domain')
}

export const onDomainCustomCodeUpdate = (can: Can) => {
  can('update', 'DomianFeature-customCode')
}

export const onDomainBulkManagementCreate = (can: Can) => {
  can('create', 'DomainFeature-bulkManagement')
}

export const onDomainOverridenByYieldbirdRead = (can: Can) => {
  can('read', 'DomainField-overriddenByYieldbird')
}

export const onDomainOverridenByYieldbirdUpdate = (can: Can) => {
  can('update', 'DomainField-overriddenByYieldbird')
}

export const onDomainAdvancedSettingsUpdate = (can: Can) => {
  can('update', 'DomianFeature-advancedSettings')
}

export const onDomainCustomBranchAlertRead = (can: Can) => {
  can('read', 'DomainFeature-alert-customBranch')
}

export const onDomainUnfilledRecoveryBaseAdUnitPathRead = (can: Can) => {
  can('read', 'DomainField-baseAdUnitPath')
}

export const onDomainUnfilledRecoveryBaseAdUnitPathUpdate = (can: Can) => {
  can('update', 'DomainField-baseAdUnitPath')
}

export const onDomainRichPlacementsMultiAnchorAccess = (can: Can) => {
  can('access', 'DomainRichPlacementsTab-multiAnchor')
}
